import React from "react"
import Box from "@material-ui/core/Box"
import ControlPanelSidebarAction from "./ControlPanelSidebarAction"

const ControlPanelSidebarActions = (props) => {
    const { handleModalCompleteProjectShowChange } = props
    return (
        <Box p={2} display="flex" flexDirection="column">
            <ControlPanelSidebarAction
                icon="IconSparcaComplete"
                label="Complete project"
                type={process.env.SPARCA_CONTROL_PANEL_SIDEBAR_PROJECT_COMPLETE}
                handleModalCompleteProjectShowChange={handleModalCompleteProjectShowChange}
            />
            <ControlPanelSidebarAction
                icon="IconSparcaSettings"
                label="Project settings"
                type={process.env.SPARCA_CONTROL_PANEL_SIDEBAR_PROJECT_SETTINGS}
            />
            <ControlPanelSidebarAction
                icon="IconSparcaAdd"
                label="Add participants"
                type={process.env.SPARCA_CONTROL_PANEL_SIDEBAR_PARTICIPANT_SETTINGS}
            />
            <ControlPanelSidebarAction icon="IconSparcaBack" label="Go back" type="back" />
        </Box>
    )
}

export default ControlPanelSidebarActions
